import Container from "../components/common/Container";
import PageHeader from "../components/common/PageHeader";
import ReportTable from "../components/Reports/EntryExitReportTable";

const EntryExitReport = () => {
  return (
    <Container>
      <PageHeader
        pageTitle="Giriş/Çıkış Raporu"
        subText="Personelin gün gün giriş-çıkış saatleri ve okutma durumları."
      />
      <ReportTable />
    </Container>
  );
};

export default EntryExitReport;
